import * as MutationTypes from './mutation-types'
import PacienteService from '@/services/paciente-service'
import RelatorioMedicoService from '@/services/relatorio-medico-service'
import { NotAuthenticatedError } from '../../models/not-authenticated-error'
import { TiposDocumentos } from '../../mixins/tipos-documentos'

export default {
  state: {
    relatorios: [],
    finalidades: [],
    resultadoSolicitacao: null
  },

  getters: {
    getRelatorios: (state) => state.relatorios,
    getRelatorioFinalidades: (state) => state.finalidades,
    getResultadoSolicitacao: (state) => state.resultadoSolicitacao
  },

  mutations: {
    [MutationTypes.GET_RELATORIOS](state, payload) {
      state.relatorios = payload
    },
    [MutationTypes.SET_RELATORIO_FINALIDADES](state, payload) {
      state.finalidades = payload
    },
    [MutationTypes.SET_RELATORIO_SOLICITACAO](state, payload) {
      state.resultadoSolicitacao = payload
    }
  },

  actions: {
    async obterRelatorios({ commit }, payload) {
      commit('setLoadingState', true)
      await PacienteService.getSolicitacoesDocumentos({ ...payload })
        .then((res) => {
          if (!res.ok && res.status >= 300) {
            if (res.status === 401) throw new NotAuthenticatedError()

            throw new Error(`HTTP error, status ${res.status}`)
          }
          if (res.status === 204) return []
          return res.json()
        })
        .then((data) => {
          commit(MutationTypes.GET_RELATORIOS, data)
          commit('setLoadingState', false)
        })
        .catch((err) => {
          commit('setLoadingState', false)
          throw err
        })
    },
    async setRelatorioFinalidades({ commit }) {
      const response = await PacienteService.getFinalidades(
        TiposDocumentos.Relatorio
      )
      commit(MutationTypes.SET_RELATORIO_FINALIDADES, response.data)
    },
    async solicitarRelatorio({ commit }, payload) {
      const response = await RelatorioMedicoService.solicitarRelatorio({ ...payload })
      commit(MutationTypes.SET_RELATORIO_SOLICITACAO, response.data)
    }
  }
}
